export { default as EventsWidget } from "./events_widget_container";
export { default as EventsWidgetFooter } from "./events_widget_footer";
export { default as WidgetEditEvents } from "./events_widget_form";

import * as EventsWidgetFactory from "./events_widget_factory";

export { EventsWidgetFactory };
